import React from "react";
import CardClass from "../../../CardClass";
import EmptyState from "../../../EmptyState";
import MUIButton from "@mui/material/Button";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import MUISwitch from "@mui/material/Switch";
import MUIIconButton from "@mui/material/IconButton";
import MUIAddIcon from "@mui/icons-material/Add";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUIGrid from "@mui/material/Grid";
import DialogSearchIssueReason from "../../../Dialog/Search/DialogSearchIssueReason";
import TileIssueReason from "../../../Tile/TileIssueReason";
import PropTypes from "prop-types";
import MainContext from "../../../../Context/MainContext/MainContext";

export default class CardAdminQueueFilterPatientIssueIssueReason extends CardClass {
  static contextType = MainContext; // For legacy class components

  constructor(props) {
    super(props);

    this.state.issueReasonDialogOpen = false;
  }

  /**
   * Render the content of the card.
   */
  renderContent() {
    const handleRemove = (issueReasonId) => {
      const filter = this.props.queue.filter;
      if (!filter["patient_issue.issue_reason_id"]?.properties?.value) {
        return;
      }
      filter["patient_issue.issue_reason_id"].properties.value = filter[
        "patient_issue.issue_reason_id"
      ].properties.value.filter((entry) => entry !== issueReasonId);
      if (
        filter["patient_issue.issue_reason_id"].properties.value.length === 0
      ) {
        delete filter["patient_issue.issue_reason_id"];
      }

      this.props.onChange({
        filter: filter,
      });
    };

    const values =
      this.props.queue?.filter?.["patient_issue.issue_reason_id"]?.properties
        ?.value || [];

    const excludeChecked =
      this.props.queue?.filter?.["patient_issue.issue_reason_id"]?.properties
        ?.operator === "not in";

    const handleExcludeToggle = (event) => {
      const filter = this.props.queue.filter;
      filter["patient_issue.issue_reason_id"].properties.operator = event.target
        .checked
        ? "not in"
        : "in";

      this.props.onChange({
        filter: filter,
      });
    };

    if (values.length > 0) {
      return (
        <>
          <MUIFormControlLabel
            sx={{ marginLeft: 0 }}
            control={
              <MUISwitch
                color="error"
                checked={excludeChecked}
                onChange={handleExcludeToggle}
              />
            }
            label="Exclude"
          />
          <MUIGrid container spacing={2}>
            {values.map((issueReasonId) => {
              return (
                <MUIGrid key={issueReasonId} item xs={12} sm={6} md={4}>
                  <TileIssueReason
                    issueReason={
                      this.context.issueReasonsIndexed[issueReasonId]
                    }
                    iconButtons={[
                      <MUIIconButton
                        onClick={() => handleRemove(issueReasonId)}
                      >
                        <MUIDeleteIcon />
                      </MUIIconButton>,
                    ]}
                  />
                </MUIGrid>
              );
            })}
            {this.renderDialog()}
          </MUIGrid>
        </>
      );
    } else {
      return (
        <>
          <EmptyState
            line1="Not Configured"
            line2="Showing all Issue Reasons"
          />
          {this.renderDialog()}
        </>
      );
    }
  }

  /**
   * Renders a search dialog of Issue Reasons
   */
  renderDialog() {
    const handleAdd = (issueReason) => {
      const filter = (this.props.queue && this.props.queue.filter) || {};
      if (!filter["patient_issue.issue_reason_id"]) {
        filter["patient_issue.issue_reason_id"] = {
          type: "set",
          properties: {
            operator: "in",
            value: [],
          },
        };
      }
      filter["patient_issue.issue_reason_id"].properties.value = [
        ...new Set([
          ...(filter["patient_issue.issue_reason_id"].properties.value || []),
          issueReason.id,
        ]),
      ];

      this.props.onChange({
        filter: filter,
      });
    };

    return (
      <DialogSearchIssueReason
        open={this.state.issueReasonDialogOpen}
        onClose={() => this.setState({ issueReasonDialogOpen: false })}
        onSelect={handleAdd}
      />
    );
  }

  /**
   * Renders add Issue Reason button
   */
  getActions() {
    const handleAdd = () => {
      this.setState({
        issueReasonDialogOpen: true,
      });
    };

    const buttonItems = [
      <MUIButton
        component="label"
        variant="outlined"
        startIcon={<MUIAddIcon />}
        onClick={handleAdd}
      >
        Add Issue Reason
      </MUIButton>,
    ];

    return buttonItems;
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "Filter: Patient Issue > Issue Reason";
  }
}
